import { Button } from "primereact/button";

import type { FilterPanelAddButtonViewProps } from "./types-add-button";

export function FilterPanelAddButtonView({
  className,
  icon,
  label,
  disabled,
  onClick,
  testId,
  rest,
}: FilterPanelAddButtonViewProps) {
  return (
    <Button
      type="button"
      className={className}
      icon={icon}
      label={label}
      text
      severity="secondary"
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
      {...rest}
    />
  );
}
